<template>
  <div id="sidebar-menu" class="d-flex">
    <!-- {{layoutobject}}
          fdsfdsf{{[layoutobject.split(' ').includes('horizontal-wrapper')]}} -->

    <ul
      class="sidebar-links custom-scrollbar"
      id="myDIV"
      :style="[
        layoutobject.split(' ').includes('horizontal-wrapper')
          ? layout.settings.layout_type == 'rtl'
            ? { '  -right': margin + 'px' }
            : { 'margin-left': margin + 'px' }
          : { margin: '0px' },
      ]"
    >
      <li class="back-btn">
        <router-link to="/">
          <img
            class="img-fluid"
            src="../../assets/images/logo/logo-icon.png"
            alt=""
        /></router-link>
        <div class="mobile-back text-right">
          <span>Back</span
          ><i class="fa fa-angle-right pl-2" aria-hidden="true"></i>
        </div>
      </li>
      <template v-for="(menuItem, index) in menuItems">
        <template v-if="menuItem.title == 'Settings'">
          <li
            class="sidebar-list"
            v-for="(CompanyLink, CompanyLinkIndex) in ExternalLinks"
            :key="'company-link' + CompanyLinkIndex"
          >
            <a
              v-if="CompanyLink.title && CompanyLink.link"
              :href="
                !CompanyLink.iframe
                  ? CompanyLink.link
                  : '/external-links/sidebar/' + getTitle(CompanyLink.title)
              "
              class="sidebar-link sidebar-title router-link-exact-active"
              :target="!CompanyLink.iframe ? '_blank' : '_self'"
              :title="CompanyLink.title"
            >
              <font-awesome-icon
                :icon="
                  CompanyLink.icon && CompanyLink.icon.name
                    ? 'fa-solid fa-' + CompanyLink.icon.name
                    : 'fa-solid fa-link'
                "
                class="f-14"
                style="vertical-align: text-bottom"
              />
              {{ CompanyLink.title }}
            </a>
          </li>
        </template>
        <li
          :key="index"
          :class="{
            active: menuItem.active,
            'sidebar-main-title': menuItem.type == 'headtitle',
          }"
          class="sidebar-list"
        >
          <!-- link title -->
          <div v-if="menuItem.type == 'headtitle'">
            <h6 class="lan-1">{{ $t(menuItem.headTitle1) }}</h6>
            <p class="lan-2">{{ $t(menuItem.headTitle2) }}</p>
          </div>
          <!-- Sub -->
          <label
            :class="'badge badge-' + menuItem.badgeType"
            v-if="menuItem.badgeType"
            >{{ $t(menuItem.badgeValue) }}</label
          >
          <a
            href="javascript:void(0)"
            class="sidebar-link sidebar-title"
            v-if="menuItem.type == 'sub' && menuItem.title == 'Settings'"
            @click="setNavActive(menuItem, index)"
          >
            <font-awesome-icon
              icon="fa-solid fa-life-ring"
              class="f-14"
              style="vertical-align: text-bottom"
            />
            <span> {{ $t(menuItem.title) }} </span>
            <div class="according-menu" v-if="menuItem.children">
              <i class="fa fa-angle-right pull-right"></i>
            </div>
          </a>
          <a
            href="javascript:void(0)"
            class="sidebar-link sidebar-title"
            v-if="
              menuItem.type == 'sub' &&
              menuItem.title == 'Assets Setting' &&
              assetsModule
            "
            @click="setNavActive(menuItem, index)"
          >
            <feather :type="menuItem.icon" class="top"></feather>
            <span> {{ $t(menuItem.title) }} </span>
            <div class="according-menu" v-if="menuItem.children">
              <i class="fa fa-angle-right pull-right"></i>
            </div>
          </a>

          <a
            href="javascript:void(0)"
            class="sidebar-link sidebar-title"
            v-if="menuItem.type == 'sub' && menuItem.title == 'Vehicle Checks'"
            @click="setNavActive(menuItem, index)"
          >
            <feather :type="menuItem.icon" class="top"></feather>
            <span> {{ $t(menuItem.title) }} </span>
            <div class="according-menu" v-if="menuItem.children">
              <i class="fa fa-angle-right pull-right"></i>
            </div>
          </a>

          <a
            href="javascript:void(0)"
            class="sidebar-link sidebar-title"
            v-if="
              menuItem.type == 'sub' &&
              menuItem.title == 'Vehicle Inspections' &&
              ShowVehicleInspections &&
              hgvModule
            "
            @click="setNavActive(menuItem, index)"
          >
            <font-awesome-icon
              icon="fa-solid fa-life-ring"
              class="f-14"
              style="vertical-align: text-bottom"
            />
            <span> {{ $t(menuItem.title) }} </span>
            <div class="according-menu" v-if="menuItem.children">
              <i class="fa fa-angle-right pull-right"></i>
            </div>
          </a>
          <!-- Link -->
          <router-link
            :to="menuItem.path"
            class="sidebar-link sidebar-title"
            v-if="menuItem.type == 'link'"
            router-link-exact-active
            exact
            v-on:click.native="hidesecondmenu()"
          >
            <feather :type="menuItem.icon" class="top"></feather>
            <span> {{ $t(menuItem.title) }} </span>
            <i
              class="fa fa-angle-right pull-right"
              v-if="menuItem.children"
            ></i>
          </router-link>

          <!-- External Link -->
          <a
            :href="menuItem.path"
            class="sidebar-link sidebar-title"
            v-if="menuItem.type == 'extLink'"
            @click="setNavActive(menuItem, index)"
          >
            <feather :type="menuItem.icon" class="top"></feather>
            <span> {{ $t(menuItem.title) }} </span>
            <i
              class="fa fa-angle-right pull-right"
              v-if="menuItem.children"
            ></i>
          </a>
          <!-- External Tab Link -->
          <a
            :href="menuItem.path"
            target="_blank"
            class="sidebar-link sidebar-title"
            v-if="menuItem.type == 'extTabLink'"
            @click="setNavActive(menuItem, index)"
          >
            <feather :type="menuItem.icon" class="top"></feather>
            <span> {{ $t(menuItem.title) }} </span>
            <i
              class="fa fa-angle-right pull-right"
              v-if="menuItem.children"
            ></i>
          </a>
          <!-- 2nd Level Menu -->
          <ul
            class="sidebar-submenu"
            v-if="menuItem.children"
            :class="{ 'menu-open': menuItem.active }"
          >
            <template v-if="menuItem.title != 'Vehicle Checks'">
              <li
                v-for="(childrenItem, index) in menuItem.children"
                :key="index"
                :class="{ active: childrenItem.active }"
              >
                <!-- Sub -->
                <a
                  class="submenu-title"
                  href="javascript:void(0)"
                  v-if="childrenItem.type == 'sub'"
                  @click="setNavActive(childrenItem, index)"
                >
                  {{ $t(childrenItem.title) }}
                  <label
                    :class="
                      'badge badge-' + childrenItem.badgeType + ' pull-right'
                    "
                    v-if="childrenItem.badgeType"
                    >{{ childrenItem.badgeValue }}</label
                  >
                  <i
                    class="fa pull-right mt-1"
                    v-bind:class="[
                      childrenItem.active
                        ? 'fa fa-angle-down'
                        : 'fa fa-angle-right',
                    ]"
                    v-if="childrenItem.children"
                  ></i>
                </a>
                <!-- Link -->
                <router-link
                  class="submenu-title"
                  :to="childrenItem.path"
                  v-if="childrenItem.type == 'link'"
                  router-link-exact-active
                  exact
                  v-on:click.native="hidesecondmenu()"
                >
                  {{ $t(childrenItem.title) }}
                  <label
                    :class="
                      'badge badge-' + childrenItem.badgeType + ' pull-right'
                    "
                    v-if="childrenItem.badgeType"
                    >{{ $t(childrenItem.badgeValue) }}</label
                  >
                  <i
                    class="fa fa-angle-right pull-right mt-1"
                    v-if="childrenItem.children"
                  ></i>
                </router-link>
                <!-- External Link -->
                <a
                  :href="childrenItem.path"
                  v-if="childrenItem.type == 'extLink'"
                  class="submenu-title"
                >
                  {{ $t(childrenItem.title) }}
                  <label
                    :class="
                      'badge badge-' + childrenItem.badgeType + ' pull-right'
                    "
                    v-if="childrenItem.badgeType"
                    >{{ $t(childrenItem.badgeValue) }}</label
                  >
                  <i
                    class="fa fa-angle-right pull-right mt-1"
                    v-if="childrenItem.children"
                  ></i>
                </a>
                <!-- External Tab Link -->
                <a
                  class="submenu-title"
                  :href="childrenItem.path"
                  target="_blank"
                  v-if="childrenItem.type == 'extTabLink'"
                >
                  {{ $t(childrenItem.title) }}
                  <label
                    :class="
                      'badge badge-' + childrenItem.badgeType + ' pull-right'
                    "
                    v-if="childrenItem.badgeType"
                    >{{ $t(childrenItem.badgeValue) }}</label
                  >
                  <i
                    class="fa fa-angle-right pull-right mt-1"
                    v-if="childrenItem.children"
                  ></i>
                </a>
                <!-- 3rd Level Menu -->
                <ul
                  class="nav-sub-childmenu submenu-content"
                  v-if="childrenItem.children"
                  :class="{ opensubchild: childrenItem.active }"
                >
                  <li
                    v-for="(childrenSubItem, index) in childrenItem.children"
                    :key="index"
                  >
                    <!-- Link -->
                    <router-link
                      :to="childrenSubItem.path"
                      v-if="childrenSubItem.type == 'link'"
                      router-link-exact-active
                      exact
                      v-on:click.native="hidesecondmenu()"
                    >
                      {{ $t(childrenSubItem.title) }}
                      <label
                        :class="
                          'badge badge-' +
                          childrenSubItem.badgeType +
                          ' pull-right'
                        "
                        v-if="childrenSubItem.badgeType"
                        >{{ $t(childrenSubItem.badgeValue) }}</label
                      >
                      <i
                        class="fa fa-angle-right pull-right"
                        v-if="childrenSubItem.children"
                      ></i>
                    </router-link>
                    <!-- External Link -->
                    <router-link
                      :to="childrenSubItem.path"
                      v-if="childrenSubItem.type == 'extLink'"
                      router-link-exact-active
                    >
                      {{ $t(childrenSubItem.title) }}
                      <label
                        :class="
                          'badge badge-' +
                          childrenSubItem.badgeType +
                          ' pull-right'
                        "
                        v-if="childrenSubItem.badgeType"
                        >{{ $t(childrenSubItem.badgeValue) }}</label
                      >
                      <i
                        class="fa fa-angle-right pull-right"
                        v-if="childrenSubItem.children"
                      ></i>
                    </router-link>
                    <!-- External Tab Link -->
                    <router-link
                      :to="childrenSubItem.path"
                      v-if="childrenSubItem.type == 'extLink'"
                      router-link-exact-active
                    >
                      {{ $t(childrenSubItem.title) }}
                      <label
                        :class="
                          'badge badge-' +
                          childrenSubItem.badgeType +
                          ' pull-right'
                        "
                        v-if="childrenSubItem.badgeType"
                        >{{ $t(childrenSubItem.badgeValue) }}</label
                      >
                      <i
                        class="fa fa-angle-right pull-right"
                        v-if="childrenSubItem.children"
                      ></i>
                    </router-link>
                  </li>
                </ul>
              </li>
            </template>
            <template v-if="menuItem.title == 'Vehicle Checks'">
              <template
                v-for="(VehicleClass, VehicleClassIndex) in VehicleClasses"
              >
                <li :key="VehicleClassIndex">
                  <!-- Link -->
                  <router-link
                    :to="'/vehicle-checks/' + VehicleClass.id"
                    class="submenu-title subMenuLink"
                    router-link-exact-active
                    exact
                    v-on:click.native="hidesecondmenu()"
                  >
                    <span>{{ VehicleClass.title }}</span>
                  </router-link>
                </li>
              </template>
            </template>
            <template
              v-if="
                menuItem.title == 'Vehicle Inspections' &&
                ShowVehicleInspections
              "
            >
              <template
                v-for="(
                  VehicleInspectionClass, VehicleInspectionClassIndex
                ) in VehicleInspectionClasses"
              >
                <li :key="VehicleInspectionClassIndex">
                  <router-link
                    :to="'/vehicle-inspections/' + VehicleInspectionClass.id"
                    class="submenu-title subMenuLink"
                    router-link-exact-active
                    exact
                    v-on:click.native="hidesecondmenu()"
                  >
                    <span>{{ VehicleInspectionClass.title }}</span>
                  </router-link>
                </li>
              </template>
            </template>
          </ul>
        </li>
        <li
          class="sidebar-list"
          v-if="menuItem.title == 'Vehicles' && trailersModule && ShowTrailer"
          :key="menuItem.id"
        >
          <router-link
            to="/trailers-list"
            class="sidebar-link sidebar-title"
            router-link-exact-active
          >
            <img
              src="@/assets/images/trailer.png"
              class="trailer-icon-margin"
            />
            <span> Trailers </span>
          </router-link>
        </li>
        <li
          class="sidebar-list"
          v-if="menuItem.title == 'Vehicles' && assetsModule && ShowAssets"
          :key="menuItem.id"
        >
          <router-link
            to="/assets/list"
            class="sidebar-link sidebar-title"
            router-link-exact-active
          >
            <img src="@/assets/images/crane.png" class="trailer-icon-margin" />
            <span> Assets </span>
          </router-link>
        </li>
        <li
          class="sidebar-list"
          v-if="
            menuItem.title == 'Drivers' &&
            fuelTrackingModule &&
            ShowFuelTracking
          "
          :key="'Fuel' + menuItem.id"
        >
          <router-link
            to="/fuel"
            class="sidebar-link sidebar-title"
            router-link-exact-active
          >
            <font-awesome-icon
              icon="fa-solid fa-zap"
              class="f-14"
              style="vertical-align: text-bottom"
            />
            <span> Fuel </span>
          </router-link>
        </li>
        <li
          class="sidebar-list"
          v-if="menuItem.title == 'Documents' && reportModule && showReports"
          :key="'Reports' + menuItem.id"
        >
          <router-link
            to="/reports"
            class="sidebar-link sidebar-title"
            router-link-exact-active
          >
            <font-awesome-icon
              icon="fa-solid fa-chart-pie"
              class="f-14"
              style="vertical-align: text-bottom"
            />
            <span> Reports </span>
          </router-link>
        </li>

        <li
          class="sidebar-list"
          v-if="menuItem.title == 'Documents' && auditModule && showAuditLogs"
          :key="'Audit_Log_' + menuItem.id"
        >
          <router-link
            to="/auditlog"
            class="sidebar-link sidebar-title"
            router-link-exact-active
          >
            <font-awesome-icon
              icon="fa-solid fa-chart-line"
              class="f-14"
              style="vertical-align: text-bottom"
            />
            <span> Audit Log </span>
          </router-link>
        </li>

        <li
          class="sidebar-list"
          v-if="menuItem.title == 'Settings'"
          :key="'Account Roles' + menuItem.id"
        >
          <router-link
            v-if="ShowAccountRoles"
            to="/account-roles"
            class="sidebar-link sidebar-title"
            router-link-exact-active
          >
            <font-awesome-icon
              icon="fa-solid fa-cogs"
              class="f-14"
              style="vertical-align: text-bottom"
            />
            <span> Account Roles </span>
          </router-link>
        </li>

        <li
          class="sidebar-list"
          v-if="menuItem.title == 'Settings'"
          :key="'Help' + menuItem.id"
        >
          <a
            href="https://pocketbox.co.uk/fleet-help/"
            class="sidebar-link sidebar-title"
            target="_blank"
            title="Help"
          >
            <font-awesome-icon
              icon="fa-solid fa-life-ring"
              class="f-14"
              style="vertical-align: text-bottom"
            />
            <span> Help </span>
          </a>
        </li>

        <li
          class="sidebar-list"
          v-if="menuItem.title == 'Settings'"
          :key="'Marketplace' + menuItem.id"
        >
          <a
            href="https://www.pocketbox.co.uk/marketplace"
            class="sidebar-link sidebar-title"
            target="_blank"
            title="Marketplace"
          >
            <font-awesome-icon
              icon="fa-solid fa-bullhorn"
              class="f-14"
              style="vertical-align: text-bottom"
            />
            <span> Marketplace </span>
          </a>
        </li>
      </template>
    </ul>
  </div>
</template>
<script>
  import { mapState } from "vuex";
  import { layoutClasses } from "../../constants/layout";
  import Axios from "axios";
  export default {
    name: "Navmenu",
    data() {
      return {
        layoutobj: {},
        ExternalLinks: [],
        hgvModule: false,
        trailersModule: false,
        reportModule: false,
        fuelTrackingModule: false,
        auditModule: false,
        assetsModule: false,
        VehicleClasses: [],
        VehicleInspectionClasses: [],
        ShowVehicle: false,
        ShowTrailer: false,
        ShowAssets: false,
        showReports: false,
        ShowFuelTracking: false,
        showAuditLogs: false,
        ShowDriver: false,
        ShowVehicleChecks: false,
        ShowVehicleInspections: false,
        ShowSettings: false,
        ShowDocuments: false,
        ShowBranches: false,
        ShowCategory: false,
        ShowLocation: false,
        ShowAccountRoles: false,
        ParentIndex: false,
        AccountRoles: [],
        FleetSubscriptionModules: [],
      };
    },
    computed: {
      ...mapState({
        menuItems: (state) => state.menu.data,
        layout: (state) => state.layout.layout,
        sidebar: (state) => state.layout.sidebarType,
        activeoverlay: (state) => state.menu.activeoverlay,
        togglesidebar: (state) => state.menu.togglesidebar,
        width: (state) => state.menu.width,
        height: (state) => state.menu.height,
        margin: (state) => state.menu.margin,
        menuWidth: (state) => state.menu.menuWidth,
      }),
      layoutobject: {
        get: function () {
          return JSON.parse(
            JSON.stringify(
              layoutClasses.find(
                (item) =>
                  Object.keys(item).pop() === this.layout.settings.layout
              )
            )
          )[this.layout.settings.layout];
        },
        set: function () {
          this.layoutobj = layoutClasses.find(
            (item) => Object.keys(item).pop() === this.layout.settings.layout
          );
          this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[
            this.layout.settings.layout
          ];
          return this.layoutobj;
        },
      },
    },
    watch: {
      width() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        window.addEventListener("scroll", this.handleScroll);
        this.handleScroll();
        if (window.innerWidth < 992) {
          const newlayout = JSON.parse(
            JSON.stringify(this.layoutobject).replace(
              "horizontal-wrapper",
              "compact-wrapper"
            )
          );
          document.querySelector(".page-wrapper").className =
            "page-wrapper " + newlayout;
          //this.$store.state.menu.margin = 0;
        } else {
          document.querySelector(".page-wrapper").className =
            "page-wrapper " + this.layoutobject;
        }

        if (
          (window.innerWidth < 1199 &&
            this.layout.settings.layout === "Tokyo") ||
          (window.innerWidth < 1199 &&
            this.layout.settings.layout === "Moscow") ||
          (window.innerWidth < 1199 && this.layout.settings.layout === "Rome")
        ) {
          this.menuItems.filter((menuItem) => {
            menuItem.active = false;
          });
        }
      },
    },
    created() {
      var Company = JSON.parse(localStorage.getItem("Company"));
      /*if(Company && Company.name){
        this.menuItems[0]['headTitle2']='To '+Company.name;
      } */
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
      if (this.$store.state.menu.width < 991) {
        this.layout.settings.layout = "Dubai";
        //this.margin = 0;
      }
      setTimeout(() => {
        const elmnt = document.getElementById("myDIV");
        this.$store.state.menu.menuWidth = elmnt.offsetWidth;
        this.$store.state.menu.menuWidth > window.innerWidth
          ? ((this.$store.state.menu.hideRightArrow = false),
            (this.$store.state.menu.hideLeftArrowRTL = false))
          : ((this.$store.state.menu.hideRightArrow = false),
            (this.$store.state.menu.hideLeftArrowRTL = true));
      }, 500);
      this.layoutobject = layoutClasses.find(
        (item) => Object.keys(item).pop() === this.layout.settings.layout
      );
      this.layoutobject = JSON.parse(JSON.stringify(this.layoutobject))[
        this.layout.settings.layout
      ];
    },
    destroyed() {
      window.removeEventListener("resize", this.handleResize);
    },
    mounted() {
      this.$root.$on("reloadVehicleClass", () => {
        this.GetVehicleClass();
      });
      this.$root.$on("reloadInspectionClass", () => {
        this.GetVehicleInspectionClass();
      });

      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        this.FleetSubscription.fleet_modules
      );
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var AccountRoles = JSON.parse(localStorage.getItem("permissions"));
      if (AccountPermissions) {
        if (AccountPermissions.Vehicle && AccountPermissions?.Vehicle?.enable) {
          this.ShowVehicle = true;
        }
        if (
          AccountPermissions?.Trailers &&
          AccountPermissions?.Trailers?.enable
        ) {
          this.ShowTrailer = true;
        }
        if (AccountPermissions?.Assets && AccountPermissions?.Assets?.enable) {
          this.ShowAssets = true;
        }
        if (
          AccountPermissions?.Reports &&
          AccountPermissions?.Reports?.enable
        ) {
          this.showReports = true;
        }
        if (AccountPermissions?.Driver && AccountPermissions?.Driver?.enable) {
          this.ShowDriver = true;
        }
        if (
          AccountPermissions?.Settings &&
          AccountPermissions?.Settings?.enable
        ) {
          this.ShowSettings = true;
        }
        if (
          AccountPermissions?.Branches &&
          AccountPermissions?.Branches?.enable
        ) {
          this.ShowBranches = true;
        }
        if (
          AccountPermissions?.Category &&
          AccountPermissions?.Category?.enable
        ) {
          this.ShowCategory = true;
        }
        if (
          AccountPermissions?.Location &&
          AccountPermissions?.Location?.enable
        ) {
          this.ShowLocation = true;
        }
        if (
          AccountPermissions?.Documents &&
          AccountPermissions?.Documents?.enable
        ) {
          this.ShowDocuments = true;
        }
        if (
          AccountPermissions["Fuel Tracking"] &&
          AccountPermissions["Fuel Tracking"]["enable"]
        ) {
          this.ShowFuelTracking = true;
        }
        if (
          AccountPermissions["Audit Logs"] &&
          AccountPermissions["Audit Logs"]["enable"]
        ) {
          this.showAuditLogs = true;
        }

        if (
          AccountPermissions["Audit Log"] &&
          AccountPermissions["Audit Log"]["enable"]
        ) {
          this.showAuditLogs = true;
        }

        if (
          AccountPermissions["Vehicle Checks"] &&
          AccountPermissions["Vehicle Checks"]["enable"]
        ) {
          this.ShowVehicleChecks = true;
        }
        if (AccountPermissions["HGV"] && AccountPermissions["HGV"]["enable"]) {
          this.ShowVehicleInspections = true;
        }
      }
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        AccountRoles.fleet_role_id == 1
      ) {
        this.ShowAccountRoles = true;
      }
      if (!FleetSubscriptionModules["Hierarchy System"]) {
        this.ShowTrailer = true;
        this.ShowAssets = true;
        this.ShowVehicle = true;
        this.showReports = true;
        this.showAuditLogs = true;
        this.ShowDriver = true;
        this.ShowVehicleChecks = true;
        this.ShowVehicleInspections = true;
        this.ShowSettings = true;
        this.ShowDocuments = true;
        this.ShowBranches = true;
        this.ShowCategory = true;
        this.ShowLocation = true;
        this.ShowFuelTracking = true;
      }
      this.menuItems.filter((items, index) => {
        if (items.title == "Vehicles" && !this.ShowVehicle) {
          this.menuItems.splice(index, 1);
        }
        if (items.title == "Drivers" && !this.ShowDriver) {
          this.menuItems.splice(index, 1);
        }
        if (items.title == "Vehicle Checks" && !this.ShowVehicleChecks) {
          this.menuItems.splice(index, 1);
        }
        if (
          items.title == "Vehicle Inspections" &&
          !this.ShowVehicleInspections
        ) {
          this.menuItems.splice(index, 1);
        }
        if (items.title == "Settings") {
          this.ParentIndex = index;
          this.AccountRoles = AccountRoles;
          this.FleetSubscriptionModules = FleetSubscriptionModules;
          this.UpdateSettingsMenu();
        }
        if (items.title == "Documents" && !this.ShowDocuments) {
          this.menuItems.splice(index, 1);
        }
        if (items.title == "Assets Setting") {
          this.menuItems[index]["children"].filter((childItem2, childIndex) => {
            if (childItem2.title == "Category" && !this.ShowCategory) {
              this.menuItems[index]["children"].splice(childIndex, 1);
            }
            if (childItem2.title == "Location" && !this.ShowLocation) {
              this.menuItems[index]["children"].splice(childIndex, 1);
            }
          });
          if (!this.ShowCategory && !this.ShowLocation) {
            this.menuItems.splice(index, 1);
          }
        }
      });

      this.menuItems.filter((items) => {
        if (items.path === this.$route.path)
          this.$store.dispatch("menu/setActiveRoute", items);
        if (!items.children) return false;
        items.children.filter((subItems) => {
          if (subItems.path === this.$route.path)
            this.$store.dispatch("menu/setActiveRoute", subItems);
          if (!subItems.children) return false;
          subItems.children.filter((subSubItems) => {
            if (subSubItems.path === this.$route.path)
              this.$store.dispatch("menu/setActiveRoute", subSubItems);
          });
        });
      });

      this.GetCompanyDetail();
      this.GetCompanySubscription();
      this.GetVehicleClass();
      this.GetVehicleInspectionClass();
    },
    methods: {
      UpdateSettingsMenu() {
        var index = this.ParentIndex;
        var AccountRoles = this.AccountRoles;
        var FleetSubscriptionModules = this.FleetSubscriptionModules;
        this.menuItems[index]["children"].forEach((childItem, childIndex) => {
          if (childItem.title == "Settings" && !this.ShowSettings) {
            this.menuItems[index]["children"].splice(childIndex, 1);
            this.UpdateSettingsMenu();
          }
          if (childItem.title == "Branches" && !this.ShowBranches) {
            this.menuItems[index]["children"].splice(childIndex, 1);
            this.UpdateSettingsMenu();
          }
          if (
            childItem.title == "Users" &&
            AccountRoles.fleet_role_id != 1 &&
            FleetSubscriptionModules["Hierarchy System"]
          ) {
            this.menuItems[index]["children"].splice(childIndex, 1);
            this.UpdateSettingsMenu();
          }
          if (
            childItem.title == "Company" &&
            AccountRoles.fleet_role_id != 1 &&
            FleetSubscriptionModules["Hierarchy System"]
          ) {
            this.menuItems[index]["children"].splice(childIndex, 1);
            this.UpdateSettingsMenu();
          }
        });
      },
      GetVehicleClass() {
        var self = this;
        var obj = { token: localStorage.getItem("token") };
        obj.type = "LeftNavigation";
        Axios.post(Endpoints.Vehicle.GetVehicleTypes, obj).then((Response) => {
          if (Response.data.success) {
            if (Object.keys(Response.data.records).length > 0) {
              Object.values(Response.data.records).forEach((classItem) => {
                self.VehicleClasses.push(classItem);
              });
            } else {
              if (localStorage.getItem("Classes")) {
                this.VehicleClasses = JSON.parse(
                  localStorage.getItem("Classes")
                );
              } else {
                Axios.post(Endpoints.VehicleChecks.GetVehicleClassList, {
                  token: localStorage.getItem("token"),
                }).then((Response) => {
                  if (Response.data.success) {
                    this.VehicleClasses = Response.data.records;
                    localStorage.setItem(
                      "Classes",
                      JSON.stringify(Response.data.records)
                    );
                  }
                });
              }
            }
          }
        });
      },
      GetVehicleInspectionClass() {
        if (localStorage.getItem("InspectionsClasses")) {
          this.VehicleInspectionClasses = JSON.parse(
            localStorage.getItem("InspectionsClasses")
          );
        } else {
          Axios.post(Endpoints.VehicleInspections.GetVehicleClasses, {
            token: localStorage.getItem("token"),
          }).then((Response) => {
            if (Response.data.success) {
              this.VehicleInspectionClasses = Response.data.records;
              localStorage.setItem(
                "InspectionsClasses",
                JSON.stringify(Response.data.records)
              );
            }
          });
        }
      },
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isHGV = FleetSubscriptionModules.HGV;
        if (isHGV) {
          this.hgvModule = true;
        }
        const isReport = FleetSubscriptionModules.Reports;
        if (isReport) {
          this.reportModule = true;
        }
        const isAudit = FleetSubscriptionModules["Audit Log"];
        if (isAudit) {
          this.auditModule = true;
        }
        const isAssets = FleetSubscriptionModules.Assets;
        if (isAssets) {
          this.assetsModule = true;
        }
        const isTrailer = FleetSubscriptionModules.Trailers;
        if (isTrailer) {
          this.trailersModule = true;
        }
        const isFuelTracking = FleetSubscriptionModules["Fuel Tracking"];
        if (isFuelTracking) {
          this.fuelTrackingModule = true;
        }
      },
      GetCompanyDetail() {
        var CompanyData = JSON.parse(localStorage.getItem("Company"));
        if (
          CompanyData.fleet_settings_key != "" &&
          CompanyData.fleet_settings_key != null
        ) {
          var CompanySettingsKey = JSON.parse(CompanyData.fleet_settings_key);
          if (typeof CompanySettingsKey.ExternalLinks != "undefined") {
            this.ExternalLinks = CompanySettingsKey.ExternalLinks;
          }
        }
      },
      handleScroll() {
        if (window.scrollY > 400) {
          if (
            this.layoutobject.split(" ").pop() === "material-type" ||
            this.layoutobject.split(" ").pop() === "advance-layout"
          )
            document.querySelector(".sidebar-main").className =
              "sidebar-main hovered";
        } else {
          if (document.getElementById("sidebar-main"))
            document.querySelector(".sidebar-main").className = "sidebar-main";
        }
      },
      setNavActive(item) {
        this.$store.dispatch("menu/setNavActive", item);
        if (
          this.layoutobject.split(" ").includes("compact-sidebar") &&
          window.innerWidth > 991
        ) {
          if (this.menuItems.some((menuItem) => menuItem.active === true)) {
            this.$store.state.menu.activeoverlay = true;
          } else {
            this.$store.state.menu.activeoverlay = false;
          }
        }
      },
      hidesecondmenu() {
        if (window.innerWidth < 991) {
          this.$store.state.menu.activeoverlay = false;
          this.$store.state.menu.togglesidebar = false;
          this.menuItems.filter((menuItem) => {
            menuItem.active = false;
          });
        } else if (this.layoutobject.split(" ").includes("compact-sidebar")) {
          this.$store.state.menu.activeoverlay = false;
          this.menuItems.filter((menuItem) => {
            menuItem.active = false;
          });
        }
      },
      handleResize() {
        this.$store.state.menu.width = window.innerWidth - 450;
      },
      getTitle(title) {
        return title
          .replace(/(?!\w|\s)./g, "-")
          .replace(/\s+/g, "-")
          .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, "$2")
          .toLowerCase();
      },
    },
  };
</script>
<style scoped>
  .submenu-title {
    font-size: 12px !important;
  }
</style>
